/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-15 17:26:06
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/SubscriptionBuy/Detail/Description/index.tsx
 */
import React from 'react';
import { useParams } from 'react-router';
import Editor from 'src/constrains/BraftEditor';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
//import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Description = (props) => {
  const {
    data,
    setData,
    setIsEmpty,
    hasError,
    setHasError,
    setHasModified,
    disableEdit,
  } = props;
  const { uuid }: any = useParams();
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  //const [reload, setReload] = React.useState(false);

  // React.useEffect(() => {
  //   setReload(true);
  //   setTimeout(() => {
  //     setReload(false);
  //   }, 5000);
  // }, [currentLanguage]);
  // const [data, setData] = React.useState('');
  // const [, setIsEmpty] = React.useState(true);
  // const [hasError, setHasError] = React.useState(false);
  return (
    <SectionWrapper
      id='salesChannelSubscriptionBuyDescription'
      title={getI18n(
        'salesChannelSubscriptionBuy.description.subscriptionBuyDescription',
      )}
      style={{ paddingBottom: 32 }}
      //containerClassName={css.containerClassName}
    >
      {/* <Skeleton loading={reload} active> */}

      <Editor
        linkSet={{
          scopeVariables: {
            SalesChannel: uuid,
          },
        }}
        disabled={disableEdit}
        data={data}
        err={hasError}
        onErrorChange={setIsEmpty}
        onChange={({ data, isEmpty }) => {
          setData(data);
          //  setIsEmpty(isEmpty);
          setHasError(false);
          setHasModified(true);
        }}
      />

      {/* </Skeleton> */}
    </SectionWrapper>
  );
};
export default Description;
